import { store } from "../store";
import { BifrostBackendApi, BifrostBackendNestApi } from "../gateways/BifrostBackendApi";
import appConfig from "../appconfig";

const getApi = () => {
	const useNestOrderPaymentFlow =
		store.getters.featureToggles &&
		store.getters.featureToggles.useNestOrderPaymentFlow;
	return useNestOrderPaymentFlow ? BifrostBackendNestApi : BifrostBackendApi;
};

// Bilka NY
// const mockData = {
// 	1651: {
// 		shopName: "Bilka Tilst",
// 		"00000000-0000-0000-0000-000000000120": [
// 			{ totalQuantity: 17, intervalIndex: 0 },
// 			{ totalQuantity: 23, intervalIndex: 1 },
// 			{ totalQuantity: 7, intervalIndex: 2 },
// 			{ totalQuantity: 11, intervalIndex: 3 }
// 		],
// 		"00000000-0000-0000-0000-000000000121": [
// 			{ totalQuantity: 11, intervalIndex: 0 },
// 			{ totalQuantity: 54, intervalIndex: 1 },
// 			{ totalQuantity: 19, intervalIndex: 2 },
// 			{ totalQuantity: 44, intervalIndex: 3 }
// 		],
// 		"6bdf2914-957d-4943-991d-c3cafef54ae2": [
// 			{ totalQuantity: 12, intervalIndex: 0 },
// 			{ totalQuantity: 7, intervalIndex: 1 },
// 			{ totalQuantity: 18, intervalIndex: 2 },
// 			{ totalQuantity: 3, intervalIndex: 3 }
// 		]
// 	},
// 	1652: {
// 		shopName: "Bilka Skalborg",
// 		"00000000-0000-0000-0000-000000000120": [
// 			{ totalQuantity: 76, intervalIndex: 0 },
// 			{ totalQuantity: 33, intervalIndex: 1 },
// 			{ totalQuantity: 58, intervalIndex: 2 },
// 			{ totalQuantity: 11, intervalIndex: 3 }
// 		],
// 		"00000000-0000-0000-0000-000000000121": [
// 			{ totalQuantity: 64, intervalIndex: 0 },
// 			{ totalQuantity: 90, intervalIndex: 1 },
// 			{ totalQuantity: 8, intervalIndex: 2 },
// 			{ totalQuantity: 11, intervalIndex: 3 }
// 		],
// 		"6bdf2914-957d-4943-991d-c3cafef54ae2": [
// 			{ totalQuantity: 20, intervalIndex: 0 },
// 			{ totalQuantity: 0, intervalIndex: 1 },
// 			{ totalQuantity: 15, intervalIndex: 2 },
// 			{ totalQuantity: 8, intervalIndex: 3 }
// 		]
// 	},
// 	1653: {
// 		shopName: "Bilka Waves, Hundige",
// 		"00000000-0000-0000-0000-000000000120": [
// 			{ totalQuantity: 21, intervalIndex: 0 },
// 			{ totalQuantity: 79, intervalIndex: 1 },
// 			{ totalQuantity: 62, intervalIndex: 2 },
// 			{ totalQuantity: 11, intervalIndex: 3 }
// 		],
// 		"00000000-0000-0000-0000-000000000121": [
// 			{ totalQuantity: 15, intervalIndex: 0 },
// 			{ totalQuantity: 39, intervalIndex: 1 },
// 			{ totalQuantity: 24, intervalIndex: 2 },
// 			{ totalQuantity: 11, intervalIndex: 3 }
// 		],
// 		"6bdf2914-957d-4943-991d-c3cafef54ae2": [
// 			{ totalQuantity: 17, intervalIndex: 0 },
// 			{ totalQuantity: 5, intervalIndex: 1 },
// 			{ totalQuantity: 20, intervalIndex: 2 },
// 			{ totalQuantity: 11, intervalIndex: 3 }
// 		]
// 	}
// };
// Foetex NY
// const mockData = {
// 	1201: {
// 		shopName: "føtex Food Bella",
// 		"00000000-0000-0000-0000-000000000120": [
// 			{
// 				totalQuantity: 4,
// 				intervalIndex: 0
// 			},
// 			{
// 				totalQuantity: 5,
// 				intervalIndex: 1
// 			},
// 			{
// 				totalQuantity: 6,
// 				intervalIndex: 2
// 			},
// 			{
// 				totalQuantity: 17,
// 				intervalIndex: 3
// 			}
// 		],
// 		"365314d2-9be3-4317-a017-9c45fdc4b6a6": [
// 			{
// 				totalQuantity: 7,
// 				intervalIndex: 0
// 			},
// 			{
// 				totalQuantity: 8,
// 				intervalIndex: 1
// 			},
// 			{
// 				totalQuantity: 9,
// 				intervalIndex: 2
// 			},
// 			{
// 				totalQuantity: 7,
// 				intervalIndex: 3
// 			}
// 		],
// 		"ad378b0a-a8f0-4ecb-83da-e0babc1880c2": [
// 			{
// 				totalQuantity: 3,
// 				intervalIndex: 0
// 			},
// 			{
// 				totalQuantity: 18,
// 				intervalIndex: 1
// 			},
// 			{
// 				totalQuantity: 1,
// 				intervalIndex: 2
// 			},
// 			{
// 				totalQuantity: 20,
// 				intervalIndex: 3
// 			}
// 		]
// 	},
// 	1203: {
// 		shopName: "føtex Food Frederiks Allé",
// 		"00000000-0000-0000-0000-000000000120": [
// 			{
// 				totalQuantity: 9,
// 				intervalIndex: 0
// 			},
// 			{
// 				totalQuantity: 8,
// 				intervalIndex: 1
// 			},
// 			{
// 				totalQuantity: 7,
// 				intervalIndex: 2
// 			},
// 			{
// 				totalQuantity: 22,
// 				intervalIndex: 3
// 			}
// 		],
// 		"365314d2-9be3-4317-a017-9c45fdc4b6a6": [
// 			{
// 				totalQuantity: 6,
// 				intervalIndex: 0
// 			},
// 			{
// 				totalQuantity: 5,
// 				intervalIndex: 1
// 			},
// 			{
// 				totalQuantity: 4,
// 				intervalIndex: 2
// 			},
// 			{
// 				totalQuantity: 4,
// 				intervalIndex: 3
// 			}
// 		],
// 		"ad378b0a-a8f0-4ecb-83da-e0babc1880c2": [
// 			{
// 				totalQuantity: 32,
// 				intervalIndex: 0
// 			},
// 			{
// 				totalQuantity: 1,
// 				intervalIndex: 1
// 			},
// 			{
// 				totalQuantity: 11,
// 				intervalIndex: 2
// 			},
// 			{
// 				totalQuantity: 10,
// 				intervalIndex: 3
// 			}
// 		]
// 	},
// 	1204: {
// 		shopName: "føtex Food Guldsmedgade",
// 		"00000000-0000-0000-0000-000000000120": [
// 			{
// 				totalQuantity: 60,
// 				intervalIndex: 0
// 			},
// 			{
// 				totalQuantity: 50,
// 				intervalIndex: 1
// 			},
// 			{
// 				totalQuantity: 40,
// 				intervalIndex: 2
// 			},
// 			{
// 				totalQuantity: 20,
// 				intervalIndex: 3
// 			}
// 		],
// 		"365314d2-9be3-4317-a017-9c45fdc4b6a6": [
// 			{
// 				totalQuantity: 30,
// 				intervalIndex: 0
// 			},
// 			{
// 				totalQuantity: 20,
// 				intervalIndex: 1
// 			},
// 			{
// 				totalQuantity: 10,
// 				intervalIndex: 2
// 			},
// 			{
// 				totalQuantity: 20,
// 				intervalIndex: 3
// 			}
// 		],
// 		"ad378b0a-a8f0-4ecb-83da-e0babc1880c2": [
// 			{
// 				totalQuantity: 5,
// 				intervalIndex: 0
// 			},
// 			{
// 				totalQuantity: 8,
// 				intervalIndex: 1
// 			},
// 			{
// 				totalQuantity: 11,
// 				intervalIndex: 2
// 			},
// 			{
// 				totalQuantity: 23,
// 				intervalIndex: 3
// 			}
// 		]
// 	},
// 	1207: {
// 		shopName: "føtex Faaborg",
// 		"00000000-0000-0000-0000-000000000120": [
// 			{
// 				totalQuantity: 1,
// 				intervalIndex: 0
// 			},
// 			{
// 				totalQuantity: 22,
// 				intervalIndex: 1
// 			},
// 			{
// 				totalQuantity: 11,
// 				intervalIndex: 2
// 			},
// 			{
// 				totalQuantity: 13,
// 				intervalIndex: 3
// 			}
// 		],
// 		"365314d2-9be3-4317-a017-9c45fdc4b6a6": [
// 			{
// 				totalQuantity: 33,
// 				intervalIndex: 0
// 			},
// 			{
// 				totalQuantity: 44,
// 				intervalIndex: 1
// 			},
// 			{
// 				totalQuantity: 55,
// 				intervalIndex: 2
// 			},
// 			{
// 				totalQuantity: 23,
// 				intervalIndex: 3
// 			}
// 		],
// 		"ad378b0a-a8f0-4ecb-83da-e0babc1880c2": [
// 			{
// 				totalQuantity: 32,
// 				intervalIndex: 0
// 			},
// 			{
// 				totalQuantity: 18,
// 				intervalIndex: 1
// 			},
// 			{
// 				totalQuantity: 10,
// 				intervalIndex: 2
// 			},
// 			{
// 				totalQuantity: 12,
// 				intervalIndex: 3
// 			}
// 		]
// 	}
// };

// Foetex Mortensaften
// const mockData = {
// 	"1303": {
// 		"shopName": "føtex Brønderslev",
// 		"00000000-0000-0000-0000-000000000101": [
// 			{
// 				"totalQuantity": 33,
// 				"intervalIndex": 0
// 			}
// 		],
// 		"00000000-0000-0000-0000-000000000102": [
// 			{
// 				"totalQuantity": 11,
// 				"intervalIndex": 0
// 			}
// 		],
// 		"00000000-0000-0000-0000-000000000104": [
// 			{
// 				"totalQuantity": 55,
// 				"intervalIndex": 0
// 			}
// 		]
// 	},
// 	"1308": {
// 		"shopName": "føtex Silkeborg, Torvet",
// 		"00000000-0000-0000-0000-000000000101": [
// 			{
// 				"totalQuantity": 4,
// 				"intervalIndex": 0
// 			}
// 		],
// 		"00000000-0000-0000-0000-000000000102": [
// 			{
// 				"totalQuantity": 4,
// 				"intervalIndex": 0
// 			}
// 		],
// 		"00000000-0000-0000-0000-000000000104": [
// 			{
// 				"totalQuantity": 4,
// 				"intervalIndex": 0
// 			}
// 		]
// 	}
// };

// Bilka Mortensaften
// const mockData = {
// 	"1651": {
// 		"shopName": "Bilka Tilst",
// 		"f2bba3d5-3cf8-46c7-a51f-32f70f672504": [
// 			{
// 				"totalQuantity": 10,
// 				"intervalIndex": 0
// 			},
// 			{
// 				"totalQuantity": 20,
// 				"intervalIndex": 1
// 			},
// 			{
// 				"totalQuantity": 5,
// 				"intervalIndex": 2
// 			},
// 			{
// 				"totalQuantity": 7,
// 				"intervalIndex": 3
// 			}
// 		],
// 		"40ef6b2c-66ba-4ab0-a54a-25ebfe02bb80": [
// 			{
// 				"totalQuantity": 20,
// 				"intervalIndex": 0
// 			},
// 			{
// 				"totalQuantity": 30,
// 				"intervalIndex": 1
// 			},
// 			{
// 				"totalQuantity": 25,
// 				"intervalIndex": 2
// 			},
// 			{
// 				"totalQuantity": 20,
// 				"intervalIndex": 3
// 			}
// 		],
// 		"78beaa15-acae-499d-91e1-2db2b10ae552": [
// 			{
// 				"totalQuantity": 40,
// 				"intervalIndex": 0
// 			},
// 			{
// 				"totalQuantity": 50,
// 				"intervalIndex": 1
// 			},
// 			{
// 				"totalQuantity": 45,
// 				"intervalIndex": 2
// 			},
// 			{
// 				"totalQuantity": 45,
// 				"intervalIndex": 3
// 			}
// 		]
// 	},
// 	"1653": {
// 		"shopName": "Bilka Waves, Hundige",
// 		"f2bba3d5-3cf8-46c7-a51f-32f70f672504": [
// 			{
// 				"totalQuantity": 10,
// 				"intervalIndex": 0
// 			},
// 			{
// 				"totalQuantity": 20,
// 				"intervalIndex": 1
// 			},
// 			{
// 				"totalQuantity": 15,
// 				"intervalIndex": 2
// 			},
// 			{
// 				"totalQuantity": 7,
// 				"intervalIndex": 3
// 			}
// 		],
// 		"40ef6b2c-66ba-4ab0-a54a-25ebfe02bb80": [
// 			{
// 				"totalQuantity": 20,
// 				"intervalIndex": 0
// 			},
// 			{
// 				"totalQuantity": 30,
// 				"intervalIndex": 1
// 			},
// 			{
// 				"totalQuantity": 25,
// 				"intervalIndex": 2
// 			},
// 			{
// 				"totalQuantity": 20,
// 				"intervalIndex": 3
// 			}
// 		],
// 		"78beaa15-acae-499d-91e1-2db2b10ae552": [
// 			{
// 				"totalQuantity": 40,
// 				"intervalIndex": 0
// 			},
// 			{
// 				"totalQuantity": 50,
// 				"intervalIndex": 1
// 			},
// 			{
// 				"totalQuantity": 45,
// 				"intervalIndex": 2
// 			},
// 			{
// 				"totalQuantity": 45,
// 				"intervalIndex": 3
// 			}
// 		]
// 	}
// };

// Foetex Juleaften / Christmas
// const mockData = {
// 	1204: {
// 		shopName: "føtex Food Bella",
// 		"8f824498-4a13-4977-9109-05b2ec2ec03d": [
// 			{ totalQuantity: 12, intervalIndex: 0 },
// 			{ totalQuantity: 7, intervalIndex: 1 },
// 			{ totalQuantity: 19, intervalIndex: 2 },
// 			{ totalQuantity: 3, intervalIndex: 3 }
// 		],
// 		"6f0a6b42-764d-4fd5-9ea6-eef14e02d58e": [
// 			{ totalQuantity: 15, intervalIndex: 0 },
// 			{ totalQuantity: 2, intervalIndex: 1 },
// 			{ totalQuantity: 18, intervalIndex: 2 },
// 			{ totalQuantity: 9, intervalIndex: 3 }
// 		],
// 		"70259def-0a0b-411a-b1ae-bab58292247d": [
// 			{ totalQuantity: 6, intervalIndex: 0 },
// 			{ totalQuantity: 20, intervalIndex: 1 },
// 			{ totalQuantity: 1, intervalIndex: 2 },
// 			{ totalQuantity: 13, intervalIndex: 3 }
// 		],
// 		"e3d2fc40-4033-4722-997d-073a81fddc9e": [
// 			{ totalQuantity: 8, intervalIndex: 0 },
// 			{ totalQuantity: 17, intervalIndex: 1 },
// 			{ totalQuantity: 5, intervalIndex: 2 },
// 			{ totalQuantity: 14, intervalIndex: 3 }
// 		]
// 	},
// 	1207: {
// 		shopName: "føtex Food Frederiks Allé",
// 		"8f824498-4a13-4977-9109-05b2ec2ec03d": [
// 			{ totalQuantity: 10, intervalIndex: 0 },
// 			{ totalQuantity: 3, intervalIndex: 1 },
// 			{ totalQuantity: 16, intervalIndex: 2 },
// 			{ totalQuantity: 7, intervalIndex: 3 }
// 		],
// 		"6f0a6b42-764d-4fd5-9ea6-eef14e02d58e": [
// 			{ totalQuantity: 19, intervalIndex: 0 },
// 			{ totalQuantity: 0, intervalIndex: 1 },
// 			{ totalQuantity: 12, intervalIndex: 2 },
// 			{ totalQuantity: 8, intervalIndex: 3 }
// 		],
// 		"70259def-0a0b-411a-b1ae-bab58292247d": [
// 			{ totalQuantity: 4, intervalIndex: 0 },
// 			{ totalQuantity: 11, intervalIndex: 1 },
// 			{ totalQuantity: 20, intervalIndex: 2 },
// 			{ totalQuantity: 2, intervalIndex: 3 }
// 		],
// 		"e3d2fc40-4033-4722-997d-073a81fddc9e": [
// 			{ totalQuantity: 17, intervalIndex: 0 },
// 			{ totalQuantity: 5, intervalIndex: 1 },
// 			{ totalQuantity: 9, intervalIndex: 2 },
// 			{ totalQuantity: 13, intervalIndex: 3 }
// 		]
// 	},
// 	1313: {
// 		shopName: "føtex Food Guldsmedgade",
// 		"8f824498-4a13-4977-9109-05b2ec2ec03d": [
// 			{ totalQuantity: 2, intervalIndex: 0 },
// 			{ totalQuantity: 18, intervalIndex: 1 },
// 			{ totalQuantity: 11, intervalIndex: 2 },
// 			{ totalQuantity: 6, intervalIndex: 3 }
// 		],
// 		"6f0a6b42-764d-4fd5-9ea6-eef14e02d58e": [
// 			{ totalQuantity: 20, intervalIndex: 0 },
// 			{ totalQuantity: 1, intervalIndex: 1 },
// 			{ totalQuantity: 14, intervalIndex: 2 },
// 			{ totalQuantity: 7, intervalIndex: 3 }
// 		],
// 		"70259def-0a0b-411a-b1ae-bab58292247d": [
// 			{ totalQuantity: 8, intervalIndex: 0 },
// 			{ totalQuantity: 15, intervalIndex: 1 },
// 			{ totalQuantity: 3, intervalIndex: 2 },
// 			{ totalQuantity: 19, intervalIndex: 3 }
// 		],
// 		"e3d2fc40-4033-4722-997d-073a81fddc9e": [
// 			{ totalQuantity: 12, intervalIndex: 0 },
// 			{ totalQuantity: 4, intervalIndex: 1 },
// 			{ totalQuantity: 17, intervalIndex: 2 },
// 			{ totalQuantity: 10, intervalIndex: 3 }
// 		]
// 	},
// 	1214: {
// 		shopName: "føtex Faaborg",
// 		"8f824498-4a13-4977-9109-05b2ec2ec03d": [
// 			{ totalQuantity: 5, intervalIndex: 0 },
// 			{ totalQuantity: 13, intervalIndex: 1 },
// 			{ totalQuantity: 9, intervalIndex: 2 },
// 			{ totalQuantity: 16, intervalIndex: 3 }
// 		],
// 		"6f0a6b42-764d-4fd5-9ea6-eef14e02d58e": [
// 			{ totalQuantity: 11, intervalIndex: 0 },
// 			{ totalQuantity: 8, intervalIndex: 1 },
// 			{ totalQuantity: 20, intervalIndex: 2 },
// 			{ totalQuantity: 2, intervalIndex: 3 }
// 		],
// 		"70259def-0a0b-411a-b1ae-bab58292247d": [
// 			{ totalQuantity: 17, intervalIndex: 0 },
// 			{ totalQuantity: 6, intervalIndex: 1 },
// 			{ totalQuantity: 14, intervalIndex: 2 },
// 			{ totalQuantity: 1, intervalIndex: 3 }
// 		],
// 		"e3d2fc40-4033-4722-997d-073a81fddc9e": [
// 			{ totalQuantity: 3, intervalIndex: 0 },
// 			{ totalQuantity: 19, intervalIndex: 1 },
// 			{ totalQuantity: 7, intervalIndex: 2 },
// 			{ totalQuantity: 15, intervalIndex: 3 }
// 		]
// 	}
// };

// Bilka Juleaften / Christmas
// const mockData = {
// 	1651: {
// 		shopName: "Bilka Tilst",
// 		"00000000-0000-0000-0000-000000000101": [
// 			{ totalQuantity: 10, intervalIndex: 0 },
// 			{ totalQuantity: 13, intervalIndex: 1 },
// 			{ totalQuantity: 12, intervalIndex: 2 },
// 			{ totalQuantity: 14, intervalIndex: 3 }
// 		],
// 		"00000000-0000-0000-0000-000000000102": [
// 			{ totalQuantity: 25, intervalIndex: 0 },
// 			{ totalQuantity: 21, intervalIndex: 1 },
// 			{ totalQuantity: 26, intervalIndex: 2 },
// 			{ totalQuantity: 23, intervalIndex: 3 }
// 		],
// 		"00000000-0000-0000-0000-000000000089": [
// 			{ totalQuantity: 30, intervalIndex: 0 },
// 			{ totalQuantity: 31, intervalIndex: 1 },
// 			{ totalQuantity: 32, intervalIndex: 2 },
// 			{ totalQuantity: 33, intervalIndex: 3 }
// 		],
// 		"3e9695c1-74ff-47f6-a019-56e68ddc86a3": [
// 			{ totalQuantity: 40, intervalIndex: 0 },
// 			{ totalQuantity: 41, intervalIndex: 1 },
// 			{ totalQuantity: 42, intervalIndex: 2 },
// 			{ totalQuantity: 43, intervalIndex: 3 }
// 		],
// 		"00000000-0000-0000-0000-000000003065": [
// 			{ totalQuantity: 50, intervalIndex: 0 },
// 			{ totalQuantity: 51, intervalIndex: 1 },
// 			{ totalQuantity: 52, intervalIndex: 2 },
// 			{ totalQuantity: 53, intervalIndex: 3 }
// 		]
// 	},
// 	1652: {
// 		shopName: "Bilka Skalborg",
// 		"00000000-0000-0000-0000-000000000101": [
// 			{ totalQuantity: 14, intervalIndex: 0 },
// 			{ totalQuantity: 15, intervalIndex: 1 },
// 			{ totalQuantity: 16, intervalIndex: 2 },
// 			{ totalQuantity: 17, intervalIndex: 3 }
// 		],
// 		"00000000-0000-0000-0000-000000000102": [
// 			{ totalQuantity: 24, intervalIndex: 0 },
// 			{ totalQuantity: 25, intervalIndex: 1 },
// 			{ totalQuantity: 26, intervalIndex: 2 },
// 			{ totalQuantity: 27, intervalIndex: 3 }
// 		],
// 		"00000000-0000-0000-0000-000000000089": [
// 			{ totalQuantity: 34, intervalIndex: 0 },
// 			{ totalQuantity: 35, intervalIndex: 1 },
// 			{ totalQuantity: 36, intervalIndex: 2 },
// 			{ totalQuantity: 37, intervalIndex: 3 }
// 		],
// 		"3e9695c1-74ff-47f6-a019-56e68ddc86a3": [
// 			{ totalQuantity: 44, intervalIndex: 0 },
// 			{ totalQuantity: 45, intervalIndex: 1 },
// 			{ totalQuantity: 46, intervalIndex: 2 },
// 			{ totalQuantity: 47, intervalIndex: 3 }
// 		],
// 		"00000000-0000-0000-0000-000000003065": [
// 			{ totalQuantity: 54, intervalIndex: 0 },
// 			{ totalQuantity: 55, intervalIndex: 1 },
// 			{ totalQuantity: 56, intervalIndex: 2 },
// 			{ totalQuantity: 57, intervalIndex: 3 }
// 		]
// 	},
// 	1653: {
// 		shopName: "Bilka Waves, Hundige",
// 		"00000000-0000-0000-0000-000000000101": [
// 			{ totalQuantity: 18, intervalIndex: 0 },
// 			{ totalQuantity: 19, intervalIndex: 1 },
// 			{ totalQuantity: 20, intervalIndex: 2 },
// 			{ totalQuantity: 21, intervalIndex: 3 }
// 		],
// 		"00000000-0000-0000-0000-000000000102": [
// 			{ totalQuantity: 28, intervalIndex: 0 },
// 			{ totalQuantity: 29, intervalIndex: 1 },
// 			{ totalQuantity: 30, intervalIndex: 2 },
// 			{ totalQuantity: 31, intervalIndex: 3 }
// 		],
// 		"00000000-0000-0000-0000-000000000089": [
// 			{ totalQuantity: 38, intervalIndex: 0 },
// 			{ totalQuantity: 39, intervalIndex: 1 },
// 			{ totalQuantity: 40, intervalIndex: 2 },
// 			{ totalQuantity: 41, intervalIndex: 3 }
// 		],
// 		"3e9695c1-74ff-47f6-a019-56e68ddc86a3": [
// 			{ totalQuantity: 48, intervalIndex: 0 },
// 			{ totalQuantity: 49, intervalIndex: 1 },
// 			{ totalQuantity: 50, intervalIndex: 2 },
// 			{ totalQuantity: 51, intervalIndex: 3 }
// 		],
// 		"00000000-0000-0000-0000-000000003065": [
// 			{ totalQuantity: 58, intervalIndex: 0 },
// 			{ totalQuantity: 59, intervalIndex: 1 },
// 			{ totalQuantity: 60, intervalIndex: 2 },
// 			{ totalQuantity: 61, intervalIndex: 3 }
// 		]
// 	}
// };

const ProductOrderCountProvider = {
	async findProductOrderCount(shopId = "") {
		const queryData = {};
		if (shopId) {
			queryData.shopId = shopId;
		}
		const result = await BifrostBackendApi.get("/product-order-count", {
			headers: { Authorization: store.getters.jwtToken },
			params: queryData
		});

		return result.data;
	},

	mergeAndRemoveShop(res, sourceKey, targetKey) {
		const sourceStore = res[sourceKey];
		const targetStore = res[targetKey];

		if (!sourceStore || !targetStore) return res;

		const sourceUuids = Object.keys(sourceStore).filter(k => k !== "shopName");

		for (const uuid of sourceUuids) {
			const sourceIntervals = sourceStore[uuid];
			const targetIntervals = targetStore[uuid];


			if (!Array.isArray(sourceIntervals) || !Array.isArray(targetIntervals)) continue;

			for (const sInterval of sourceIntervals) {
				const tInterval = targetIntervals.find(i => i.intervalIndex === sInterval.intervalIndex);
				if (tInterval) {
					tInterval.totalQuantity += sInterval.totalQuantity;
				}
			}
		}

		delete res[sourceKey];

		return res;
	},

	async findProductIntervalCount({ productIds, intervals }) {
		// return mockData;
		// // eslint-disable-next-line no-unreachable
		const queryData = {
			productIds,
			intervals,
			tenantId: appConfig.tenantId
		};
		const result = await getApi().get("/product-monitoring", {
			headers: { Authorization: store.getters.jwtToken },
			params: queryData
		});

		return result.data;
	}
};

export default Object.freeze(ProductOrderCountProvider);
